















import { computed, defineComponent, toRefs } from '@vue/composition-api';
import Vue, { PropType } from 'vue';
import CreativeIframeDrawer from '@/components/common/creative-iframe-drawer/index.vue';

export default defineComponent({
  components: {
    CreativeIframeDrawer,
  },
  model: {
    prop: 'visible',
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: '',
    },
    events: {
      type: Array as PropType<Array<string>>,
      default: () => [],
    },
    initData: {
      type: Object as PropType<Promise<Record<string, unknown>>>,
      default: () => ({}),
    },
    permanentMode: {
      type: Boolean,
      default: false,
    },
    drawerTop: {
      type: String,
    },
  },
  setup(props, { emit }) {
    const { visible } = toRefs(props);
    const _visible = computed({
      get() {
        return visible.value;
      },
      set(val) {
        emit('input', val);
      },
    });

    const onClose = () => {
      _visible.value = false;
    };

    const onSuccess = data => {
      emit('update', data);
      onClose();
    };

    const _drawerTop = computed(() => props.drawerTop ?? `${Vue.prototype.$TTAMUI?.headerHeight}px`);

    return {
      _visible,
      _drawerTop,
      onClose,
      onSuccess,
    };
  },
});
